
export class SubgroupImportModel {
  counter: number = 0;
  groupCode: string = "";
  code: string = "";
  name: string = "";

  constructor(counter: number,
    groupCode: string,
    code: string,
    name: string
  ){
    this.counter = counter;
    this.groupCode = groupCode;
    this.code = code;
    this.name = name;
  }
}